<template>
<a-form id="form-detail-banner" :form="formDetail" class="row" layout="horizontal" @submit="submitSaveBanner">

          <a-form-item class="col-md-6">
            <h5>Imagen banner web: {{visibleDrawer}}</h5>

            <a-upload-dragger
                name="image_web"
                :multiple="false"
                :showUploadList="false"
                class="avatar-uploader"
                action="#" @change="handleChangeUploadWeb">

                <img v-if="imageUrlWeb" :src="imageUrlWeb" alt="avatar" class="rounded-pill" style="max-height:50px; max-width:200px" />
                <!-- <a-icon  v-if="isLoadingWeb" type="loading" /> -->

                <div class="row" v-if="imageUrlWeb == ''">
                    <div class="col-sm-3">

                        <p class="ant-upload-drag-icon">
                            <a-icon  :type="isLoadingWeb ? 'loading' : 'inbox'" />
                        </p>
                    </div>
                    <div class="col-sm-9">
                        <p class="ant-upload-text">Clic aquí o arrastre archivo aqui.</p>
                        <p class="ant-upload-hint">Soporta archivos .jpg </p>
                    </div>
                </div>
            </a-upload-dragger>
          </a-form-item>
          
          <a-form-item class="col-md-6">
            <h5>Imagen banner Movil</h5>

             <a-upload-dragger
                name="image_movile"
                :multiple="false"
                :showUploadList="false"
                class="avatar-uploader"
                action="#" @change="handleChangeUploadMovil">

                <img v-if="imageUrlMovil" :src="imageUrlMovil" alt="avatar" class="rounded-pill" style="max-height:50px; max-width:200px" />

                <div class="row" v-if="imageUrlMovil == ''">
                    <div class="col-sm-3">

                        <p class="ant-upload-drag-icon">
                            <a-icon  :type="isLoadingMovil ? 'loading' : 'inbox'" />
                        </p>
                    </div>
                    <div class="col-sm-9">
                        <p class="ant-upload-text">Clic aquí o arrastre archivo aqui.</p>
                        <p class="ant-upload-hint">Soporta archivos .jpg </p>
                    </div>
                </div>
            </a-upload-dragger>

          </a-form-item>

          <!-- <a-divider dashed/> -->

          <!-- <a-form-item class="col-md-12">
              <h5>Tipo de banner:</h5>
              <a-radio-group  v-model="banner.type">
                <a-radio defaultChecked value="PERFILADO" >Banner perfilado</a-radio>
                <a-radio  value="GENERAL" >Banner general</a-radio>
              </a-radio-group>

          </a-form-item> -->
          <!-- <a-form-item class="col-md-2">
               <h5>Orden:</h5>
             <a-select placeholder="# 1">
               <a-select-option key="1" value="1">1</a-select-option>
             </a-select>
          </a-form-item> -->
          <a-form-item class="col-md-4">
              <h5>Ciudad:</h5>
             <a-select v-decorator="['city', { rules: [], initialValue: '' }]"  placeholder="Ej. Bogotá"  >
               <!-- <a-select-option key="" value="" >Todas las ciudades</a-select-option> -->
               <a-select-option  :value="city.code" v-for="city in cities" :key="city.code">{{city.name}}</a-select-option>
             </a-select>
          </a-form-item>
          <a-form-item class="col-md-4">
              <h5>Posición:</h5>
             <a-select placeholder="Ej. Banner Principal" v-decorator="['position', { rules: [], initialValue: positions[0].name }]" >
               <a-select-option v-for="pos in positions" :key="pos.name" :value="pos.name">{{pos.description}}</a-select-option>
             </a-select>
          </a-form-item>

            <a-form-item class="col-md-4">
                <h5>Nombre de Campaña:</h5>
                <a-input label="Nombre de campaña"  v-decorator="['campaignName', { rules: [{ required: true, message: 'Campo requerido!' }] }]" placeholder="Ej. Jabon Dorado Promo" />
            </a-form-item>

            <a-form-item class="col-md-5">
                <h5>Enlace:</h5>
                <a-input v-decorator="['redirectUrl', { rules: [] }]" placeholder="Ej. http://www.farmatodo.com.co" >
                    <a-icon slot="suffix" type="link"></a-icon>
                </a-input>
            </a-form-item>
            <a-form-item class="col-md-3">
                <h5>Creativo:</h5>
                <a-input v-decorator="['creative', { rules: [] }]" placeholder="Ej. xxxx" />
            </a-form-item>
            <a-form-item class="col-md-2">
                <h5>Home:</h5>
                <a-switch v-decorator="['home', { rules: [], valuePropName: 'checked' }]"/>
            </a-form-item>
            <a-form-item class="col-md-2">
                <h5>Pinned:</h5>
                <a-switch v-model="isPinned" :loading="isLoadingPinned"/>
            </a-form-item>
             <a-form-item class="col-md-2">
                <h5>Orden:</h5>
                <a-input v-decorator="['order', { rules: [] }]" placeholder="Ej. 3" />
            </a-form-item>

             <!-- <a-divider dashed > Fecha y hora </a-divider>             -->
            <a-form-item class="col-md-3">
                <h5>Fecha de publicación:</h5>
                <a-date-picker :disabledDate="disabledDate" v-decorator="['datePublished', { rules: [{ required: true, message: 'Campo requerido!' }] }]" placeholder="Ej. 23-12-2019" format="DD-MM-YYYY" ></a-date-picker>
            </a-form-item>
            <a-form-item class="col-md-3">
                <h5>Hora de publicación:</h5>
                <a-time-picker v-decorator="['timePublished', { rules: [] }]"  placeholder="Ej. 9:00 PM" use12Hours format="hh:mm A"  :minuteStep="10" />
            </a-form-item>

             <a-form-item class="col-md-3">
                <h5>Fecha de Finalización:</h5>
                <a-date-picker :disabledDate="disabledDate" v-decorator="['dateFinished', { rules: [{ required: true, message: 'Campo requerido!' }] }]" placeholder="Ej. 23-12-2019" format="DD-MM-YYYY"></a-date-picker>
            </a-form-item>
            <a-form-item class="col-md-3">
                <h5>Hora de Finalización:</h5>
                <a-time-picker v-decorator="['timeFinished', { rules: [] }]" placeholder="Ej. 9:00 PM" use12Hours format="hh:mm A"  :minuteStep="10"  />
            </a-form-item>

            <a-form-item class="col-md-12" v-if="isMainBanner">
                <h5>Perfiles:</h5>

                <a-select
                    mode="multiple"
                    placeholder="Seleccione los perfiles aplicables..."
                    :value="selectedItemsProfiles"
                    @change="handleChangeProfiles"

                    style="width: 100%"
                >
                    <a-select-option v-for="item in Profiles" :key="item.idCluster" :value="item.idCluster">
                    {{item.namePerfil}}
                    </a-select-option>
                </a-select>
            </a-form-item>

             <a-form-item class="col-md-12">
                <h5>Categoría:</h5>
                   <a-tree-select
                      :treeData="dataCategories"
                      :value="selectedItemsCategories"
                      @change="onChangeCategories"
                      treeCheckable
                      :showCheckedStrategy="SHOW_PARENT"
                      placeholder="Puedes seleccionar diferentes categorías y subcategoría..."
                      showSearch/>
            </a-form-item>

        <div :style="{
                position: 'absolute',
                left: 0,
                bottom: 0,
                width: '100%',
                borderTop: '1px solid #e9e9e9',
                padding: '10px 16px',
                background: '#fff',
                textAlign: 'right',
              }" >

        <a-button v-if="idBanner" :style="{marginRight: '8px', float:'left'}"  @click="onDeleteBanner(idBanner)" :loading="loadingDelete"> Borrar </a-button>

        <a-button :style="{marginRight: '8px'}"  @click="$emit('closeDetail', false)" > Cerrar </a-button>

        <a-button v-if="!idBanner" :style="{marginRight: '8px'}" type="primary" html-type="submit" :loading="loadingSave">Guardar Banner</a-button>
        <a-button v-else :style="{marginRight: '8px'}" type="primary" :loading="loadingSave" html-type="submit">Actualizar Banner</a-button>

      </div>

    </a-form>
</template>

<script>
import { TreeSelect } from 'ant-design-vue'

import moment from 'moment'

import { RepositoryFactory } from '@/repository/RepositoryFactory'

import UploadRepository from '@/repository/uploadRepository'

const AlgoliaRepository = RepositoryFactory.get('algolia')

const BannersRepository = RepositoryFactory.get('banners')
const CategoriesRepository = RepositoryFactory.get('categories')
const ProfilesRepository = RepositoryFactory.get('profiles')
const LocationRepository = RepositoryFactory.get('location')

const SHOW_PARENT = TreeSelect.SHOW_PARENT

export default {
  name: 'DetailBanner',

  props: ['banner', 'positions', 'visibleDrawer'],

  data () {
    return {
      isLoadingWeb: false,
      isLoadingMovil: false,
      isLoadingPinned: false,
      isPinned: false,

      imageUrlWeb: '',
      imageUrlMovil: '',
      loadingSave: false,
      loadingDelete: false,

      selectedItemsProfiles: [],
      selectedItemsCategories: [],

      idBanner: null,

      SHOW_PARENT,
      indexSliders: null,
      position3: 'test',
      Profiles: [],
      formDetail: this.$form.createForm(this, { name: 'banner' }),
      categories: [],

    }
  },
  computed: {

    filteredOptionsProfiles() {
      return OPTIONS.filter(o => !this.selectedItemsProfiles.includes(o))
    },
    dataCategories: function() {
      return this.categories.map((item, index) => {
        return {
          title: item.name,
          value: item.id,
          key: item.id,
          children: [],
          // children: item.children.map((sub, index) => {

          //   if(sub.id == 0){
          //     sub.id = Math.random().toString(36).substring(2);
          //     sub.name = "XXXX"
          //   };

          //   return {
          //     title: sub.name,
          //     value: sub.id,
          //     disabled: sub.name == "XXXX" ? true : false,
          //     key: sub.id,
          //   }
          // }),
        }
      })
    },
    // isUpdated: function () {
    //   return this.slider.hasOwnProperty('objectID')
    // },
    cities() {
      return LocationRepository.getCities().map((item) => {
        return item
      })
    },
    isMainBanner() {
      console.log(this.formDetail)
      return true;
    },
  },

  mounted() {
    this.fetchProfiles()
    this.fetchCategories()
    this.setDataForm()
  },

  watch: {

    banner: function(data) {
      this.setDataForm()
    },
  },

  methods: {

    setDataForm() {
      this.idBanner = this.banner.idBanner || null

      this.fetchPinnedStatus(this.idBanner)

      this.selectedItemsProfiles = this.banner.listClusteres || [0]
      this.selectedItemsCategories = this.banner.listCategories || []

      this.imageUrlWeb = this.banner.imageDesktop || ''
      this.imageUrlMovil = this.banner.imageMobile || ''

      console.log(this.banner.home)
      const object = {
        'id': this.banner.idBanner || null,
        'redirectUrl': this.banner.redirectUrl || null,
        'idWebSafeBanner': this.banner.idWebSafeBanner || null,
        'directionBanner': this.banner.directionBanner || null,
        'bannerWeb': true,
        'imageDesktop': this.banner.imageDesktop || null,
        'imageMobile': this.banner.imageMobile || null,
        'campaignName': this.banner.campaignName || null,
        'creative': this.banner.creative || null,
        'home': this.banner.home || false,
        'typeImage': this.banner.position || null,
        'city': this.banner.city || '',
        'order': this.banner.order || '',
        'datePublished': this.$moment(this.banner.dateTimePublished),
        'timePublished': this.$moment(this.banner.dateTimePublished),
        'dateFinished': this.$moment(this.banner.dateTimeFinished),
        'timeFinished': this.$moment(this.banner.dateTimeFinished),
        'listClusteres': this.banner.listClusteres || [0],
        'listCategories': this.banner.listCategories || null,
      }

      this.formDetail.setFieldsValue(object)
      console.log(this.formDetail.getFieldValue('home'))
    },

    submitSaveBanner(e) {
      e.preventDefault()

      this.formDetail.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)

          const datePublished = values.datePublished
          const timePublished = values.timePublished

          const dateTimePublished = this.mergeDateTime(values.datePublished, values.timePublished)
          const dateTimeFinished = this.mergeDateTime(values.dateFinished, values.timeFinished)

          const object = {
            'id': this.idBanner || null,
            'redirectUrl': values.redirectUrl || '',
            'idWbeSafeBanner': 'nsdfsbndfiojsdu84932o29430',
            'directionBanner': true,
            'bannerWeb': true,
            'imageDesktop': this.imageUrlWeb || '',
            'imageMobile': this.imageUrlMovil || '',
            'campaignName': values.campaignName || '',
            'creative': values.creative || '',
            'home': values.home || false,
            'typeImage': values.position || '',
            'city': values.city || '',
            'order': values.order || 0,
            'dateTimePublished': dateTimePublished,
            'dateTimeFinished': dateTimeFinished,
            'listClusteres': this.selectedItemsProfiles || [0],
            'listCategories': this.selectedItemsCategories.length > 0 ? this.selectedItemsCategories : [0],
          }

          // console.log(object)

          this.idBanner != null ? this.onEditSlider(object) : this.onSaveSlider(object)
        }

        // console.log(this.form.timePublished, this.form.timeFinished)
      })
    },

    async onSaveSlider(object) {
      try {
        this.loadingSave = true
        BannersRepository.insert(object).then(async ({ data }) => {
          const lastBannerResponse = await BannersRepository.getLastBanner()
          const lastBanner = lastBannerResponse.data[0]
          const lastBannerId = lastBanner && lastBanner.id
          if (lastBannerId) {
            await BannersRepository.updatePinned(lastBannerId, this.isPinned)
          }

          this.loadingSave = false
          this.$notification['success']({
            message: data.data.message,
            description: data.data.message,
          })

          this.$emit('updateFetchBanner')
          this.$emit('closeDetail', false)
        })
      } catch (error) {
        this.$notification['warning']({
          message: error.code,
          description: error.message,
        })
      }
    },

    async onEditSlider(object) {
      try {
        this.loadingSave = true
        BannersRepository.edit(object).then(async ({ data }) => {
          await BannersRepository.updatePinned(this.idBanner, this.isPinned)

          this.loadingSave = false
          console.log(data)
          this.$notification['success']({
            message: data.data.message,
            description: data.data.message,
          })

          this.$emit('updateFetchBanner')
          this.$emit('closeDetail', false)
        })
      } catch (error) {
        this.$notification['warning']({
          message: error.code,
          description: error.message,
        })
      }
    },

    async onDeleteBanner(id) {
      // this.$success({
      //     title: 'This is a success message',
      //     // JSX support
      //     content: (
      //       <div>
      //         <p>some messages...some messages...</p>
      //         <p>some messages...some messages...</p>
      //       </div>
      //     ),
      //   });

      try {
        this.loadingDelete = true
        BannersRepository.delete(id).then(({ data }) => {
          this.loadingDelete = false
          console.log(data)
          this.$notification['success']({
            message: data.data.message,
            description: data.data.message,
          })

          this.$emit('updateFetchBanner')
          this.$emit('closeDetail', false)
        })
      } catch (error) {
        this.$notification['warning']({
          message: error.code,
          description: error.message,
        })
      }

      // this.$confirm({
      //   title: '¿Deseas borrar este banner?',
      //   content: 'Si presiona aceptar será eliminado en la página web en producción',
      //   onOk() {

      //   },
      //   onCancel() {},
      // })
    },
    onChangeCategories(value) {
      console.log('onChangeCategories ', value)
      this.selectedItemsCategories = value
      // this.banner.listCategories = this.selectedItemsProfiles
    },
    handleChangeProfiles(selectedItems) {
      this.selectedItemsProfiles = selectedItems
      // this.banner.listCategories = this.selectedItemsProfiles
    },
    handleChangeUploadWeb(info) {

      if(!this.isLoadingWeb) {
        console.log(info)

        this.imageUrlWeb = ''
        this.isLoadingWeb = true

        try {
          UploadRepository.uploadImageAdjustable(info.file.originFileObj).then(({ data }) => {
            this.imageUrlWeb = data.servingUrl
            this.banner.imageUrlWeb = data.servingUrl
            this.isLoadingWeb = false
          })
        } catch (error) {
          console.log(error)
          this.$notification['warning']({
            message: error.code,
            description: error.message,
          })
        }
      }
    },
    handleChangeUploadMovil(info) {
      if(!this.isLoadingMovil){
        this.imageUrlMovil = ''
        this.isLoadingMovil = true
        try {
          UploadRepository.uploadImageAdjustable(info.file.originFileObj).then(({ data }) => {
            this.imageUrlMovil = data.servingUrl
            this.banner.imageUrlMovil = data.servingUrl
            this.isLoadingMovil = false
          })
        } catch (error) {
          console.log(error)
          this.$notification['warning']({
            message: error.code,
            description: error.message,
          })
        }
      }

    },
    beforeUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      if (!isJPG) {
        this.$message.error('You can only upload JPG file!')
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('Image must smaller than 2MB!')
      }
      return isJPG && isLt2M
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },

    async fetchProfiles() {
      try {
        const { data } = await ProfilesRepository.getProfiles()

        console.log(data.data)
        this.Profiles = data.data
      } catch (error) {
        this.$notification['warning']({
          message: error.code,
          description: error.message,
        })
      }
    },

    async fetchCategories() {
      try {
        const { data } = await CategoriesRepository.get()

        console.log(data)
        const homeCategory = {
          id: 0,
          name: 'Home (Página de Inicio)',
          url: 'http://lh3.googleusercontent.com/nB3jhpuGy3Tmw9FHXmE8PvkheE9PowhhPAnhejuT0ZfKnAOp08UlKwnCzH4nKcjM2KaFWJgPEFyTJo600tvZ-6aEmD1rJ_YuWOA',
          primaryColor: '#84D24C',
          children: [],
        }
        console.log(homeCategory)

        data.departmentList.unshift(homeCategory)

        this.categories = data.departmentList

        // this.categories.unshift({homeCategory})
      } catch (error) {
        this.$notification['warning']({
          message: error.code,
          description: error.message,
        })
      }
    },

    async fetchPinnedStatus(bannerId) {
      if (!bannerId) {
        this.isPinned = false
        return
      }

      try {
        this.isLoadingPinned = true
        const { data } = await BannersRepository.getBannerById(bannerId)
        this.isPinned = data.isPinned === '1'
      } catch (error) {
        console.error('Error fetching pinned status:', error)
        this.isPinned = false
      } finally {
        this.isLoadingPinned = false
      }
    },

    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().subtract('1', 'day').endOf('day')
    },

    mergeDateTime(date, time) {
      if (date == null) return null

      const dateTimePublished = moment(moment(date).format('YYYY/MM/DD') + ' ' + moment(time, 'hh:mm A').format('HH:mm:ss'))

      return moment(dateTimePublished).format('YYYY-MM-DD HH:mm:ss')
    },

  },
  // mounted() {
  //   const client = algoliasearch('testingYA3RG061BL', '3884ebb0619b13dcec74002f555c8990')
  //   this.indexSliders = client.initIndex('banners')
  // },
}
</script>

<style lang="css">

    .ant-drawer-title{
        color:#001e62;
        font-weight: bold;
        font-size: 15pt;
        font-family: 'Open Sans Condensed', sans-serif;
        text-transform: uppercase
    }
    h5{
        color:#001e62;
        font-weight: bold;
        font-size: 12pt;
        font-family: 'Open Sans Condensed', sans-serif;
    }
    p.ant-upload-drag-icon {
        text-align: center;
        padding: 0px 10px;
        display: block;
        margin: 0px!important;
    }

    p.ant-upload-text {

        font-size: 14px!important;

    }

    /* p.ant-upload-hint {
        float: left;
        width: 70%;
    } */

    .ant-upload-drag-container {padding: 0px; line-height: 13px;}

    span.ant-upload.ant-upload-btn {
        padding: 0px!important;
        /* border: 1px #ddd dotted; */
    }

    .ant-upload.ant-upload-drag {
        border: 2px dashed #e4e9f0;
        background-color: transparent;
        height: 70px;
    }

    .ant-upload.ant-upload-drag p.ant-upload-text{
            margin: 10px 0 1px;
    }

    #form-detail-banner{
      padding-bottom: 40px
    }
</style>
